import gql from "graphql-tag";
import LocalBookFragments from '@/graphql/LocalBookFragments';

const LOCAL_BOOK_CORE_FRAGMENT = LocalBookFragments.localBookCoreFragment;
const LOCAL_BOOK_DETAILS_FRAGMENT = LocalBookFragments.localBookDetailsFragment;
const LOCAL_BOOK_ADMIN_LIST_FRAGMENT = LocalBookFragments.localBookAdminListFragment;
const LOCAL_BOOK_SEARCH_RESULT_FRAGMENT = LocalBookFragments.localBookSearchResultFragment;

export default {
  getLocalBooks: gql`
    query getLocalBooks(
      $page: Int,
      $itemsPerPage: Int,
      $simplesearch: String,
      $order: [LocalBookFilter_order],
      $showUnlisted: Boolean
    ) {
      localBooks(
        page: $page,
        itemsPerPage: $itemsPerPage,
        simplesearch: $simplesearch,
        order: $order,
        showUnlisted: $showUnlisted
      ) {
        collection {
          ...LocalBookDetails
        }
        paginationInfo {
          itemsPerPage
          lastPage
          totalCount
          hasNextPage
        }
      }
    }
    ${LOCAL_BOOK_DETAILS_FRAGMENT}
  `,

  getLocalBook: gql`
    query getLocalBook($id: ID!) {
      localBook(id: $id) {
        ...LocalBookDetails
      }
    }
    ${LOCAL_BOOK_DETAILS_FRAGMENT}
  `,

  getLocalBooksForAdminList: gql`
    query getLocalBooksForAdminList(
      $page: Int,
      $itemsPerPage: Int,
      $simplesearch: String,
      $order: [LocalBookFilter_order],
      $showUnlisted: Boolean
    ) {
      localBooks(
        page: $page,
        itemsPerPage: $itemsPerPage,
        simplesearch: $simplesearch,
        order: $order,
        showUnlisted: $showUnlisted
      ) {
        collection {
          ...LocalBookAdminList
        }
        paginationInfo {
          itemsPerPage
          lastPage
          totalCount
          hasNextPage
        }
      }
    }
    ${LOCAL_BOOK_ADMIN_LIST_FRAGMENT}
  `,

  searchLocalBooks: gql`
    query searchLocalBooks($simplesearch: String, $itemsPerPage: Int, $page: Int) {
      localBooks(simplesearch: $simplesearch, itemsPerPage: $itemsPerPage, page: $page) {
        collection {
          ...LocalBookSearchResult
        }
      }
    }
    ${LOCAL_BOOK_SEARCH_RESULT_FRAGMENT}
  `,

  // Backend `title` filter is partial-match (LIKE) and case-insensitive — callers
  // must filter results client-side by normalized base title to drop unrelated hits.
  getLocalBooksByTitle: gql`
    query getLocalBooksByTitle($title: String!, $itemsPerPage: Int) {
      localBooks(title: $title, itemsPerPage: $itemsPerPage) {
        collection {
          ...LocalBookCore
        }
      }
    }
    ${LOCAL_BOOK_CORE_FRAGMENT}
  `,
};
